module.exports = __webpack_public_path__ + "static/media/a32.a55082c7.jpg";